(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire46a9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire46a9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jU1Wv", function(module, exports) {

var $l8I3q = parcelRequire("l8I3q");
const $9cf00ee2bbca7138$var$handleButtonClick = (button)=>{
    const originalText = button.textContent;
    const buttonObserver = new MutationObserver(()=>{
        if (button.textContent !== originalText) {
            buttonObserver.disconnect();
            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer?.renderContents) {
                (0, $l8I3q.updateElements)([
                    ".drawer__inner",
                    ".cart-count-bubble"
                ]);
                cartDrawer.renderContents();
                cartDrawer.classList.remove("is-empty");
            }
        }
    });
    buttonObserver.observe(button, {
        attributes: true
    });
};
const $9cf00ee2bbca7138$var$findAndHandleButtons = ()=>{
    const buttons = document.querySelectorAll(".swym-add-to-cart-btn");
    if (buttons.length > 0) {
        buttons.forEach((button)=>{
            button.addEventListener("click", ()=>$9cf00ee2bbca7138$var$handleButtonClick(button));
        });
        return true;
    }
    return false;
};
const $9cf00ee2bbca7138$var$handleWishlistAddToCart = ()=>{
    const mainObserver = new MutationObserver((mutations, observer)=>{
        const hasFoundButtons = $9cf00ee2bbca7138$var$findAndHandleButtons();
        if (hasFoundButtons) observer.disconnect();
    });
    mainObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
};
$9cf00ee2bbca7138$var$handleWishlistAddToCart();

});
parcelRegister("l8I3q", function(module, exports) {

$parcel$export(module.exports, "updateElements", () => $07d5380be57d91f1$export$c5303087167e431c);
const $07d5380be57d91f1$export$c5303087167e431c = async (selectors, sectionId)=>{
    try {
        const response = await fetch(sectionId ? `?sections=${sectionId}` : location.href);
        const html = sectionId ? (await response.json())[sectionId] : await response.text();
        const newdoc = new DOMParser().parseFromString(html, "text/html");
        if (typeof selectors === "string") selectors = [
            selectors
        ];
        for (const selector of selectors){
            const elements = document.querySelectorAll(selector);
            const newElements = newdoc.querySelectorAll(selector);
            if (elements.length !== newElements.length) throw new Error("Elements count mismatch for: " + selector);
            elements.forEach((element, index)=>{
                const newElement = newElements[index];
                if (element && newElement) element.outerHTML = newElement.outerHTML;
            });
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error({
            error: error
        });
    }
};

});


parcelRegister("e0FTq", function(module, exports) {
document.addEventListener("click", (event)=>{
    if (event.target instanceof HTMLElement) {
        const isPaginationItem = event.target.closest(".pagination__item");
        if (isPaginationItem) {
            const productGridContainer = document.querySelector(".product-grid-container");
            if (productGridContainer) {
                const header = document.querySelector("header");
                const headerHeight = header ? header.offsetHeight : 0;
                const elementPosition = productGridContainer.getBoundingClientRect().top + window.pageYOffset - headerHeight - 40;
                window.scrollTo({
                    top: elementPosition,
                    behavior: "smooth"
                });
            } else window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    }
});

});

parcelRegister("6R7pS", function(module, exports) {
function $5e9671ce07f3b44c$var$initRepairNetwork(componentNode) {
    if (!(componentNode instanceof HTMLElement)) return;
    if (componentNode.dataset.repairNetworkBound === "true") return;
    componentNode.dataset.repairNetworkBound = "true";
    const repairSelect = componentNode.querySelector("[data-repair-network-select]");
    if (!(repairSelect instanceof HTMLSelectElement)) return;
    const cardNodes = Array.from(componentNode.querySelectorAll("[data-repair-network-item]"));
    const repairCards = cardNodes.filter((node)=>node instanceof HTMLElement).map((element)=>({
            element: element,
            key: element.dataset.key ?? ""
        }));
    const showSelectedByKey = (selectedKey)=>{
        repairCards.forEach(({ element: element, key: key })=>{
            if (key === selectedKey) element.removeAttribute("hidden");
            else element.setAttribute("hidden", "hidden");
        });
    };
    repairSelect.addEventListener("change", ()=>showSelectedByKey(repairSelect.value));
    showSelectedByKey(repairSelect.value);
}
function $5e9671ce07f3b44c$var$mountRepairNetworksIn(rootNode) {
    Array.from(rootNode.querySelectorAll("[data-repair-network]")).forEach($5e9671ce07f3b44c$var$initRepairNetwork);
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>$5e9671ce07f3b44c$var$mountRepairNetworksIn(document));
else $5e9671ce07f3b44c$var$mountRepairNetworksIn(document);
document.addEventListener("shopify:section:load", (event)=>{
    const targetNode = event.target;
    if (targetNode instanceof HTMLElement) $5e9671ce07f3b44c$var$mountRepairNetworksIn(targetNode);
});

});

parcelRequire("jU1Wv");
parcelRequire("e0FTq");
parcelRequire("6R7pS");

})();
//# sourceMappingURL=global.js.map
